<template>
  <div>
    <!-- 列表头部 -->
    <!-- <div class="com-list-header">
      <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="name" placeholder="请输入">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div> -->

    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加修复方案
          </el-button>
        </el-row>
      </div>
      <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{ scope.$index+1 }}</template>
        </el-table-column>
        <el-table-column prop="title" label="文件名" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="collectionName" label="文件大小" min-width="11%"></el-table-column> -->

        <!-- 操作 -->
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <a class="m-btn mr-10" @click="preview(scope.row.id, false)">预览</a>
            <a class="m-btn mr-10 m-danger" @click="preview(scope.row.id, true)">编辑</a>
            <a class="m-btn mr-10" @click="download(scope.row)">下载</a>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container paging">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>

    </div>

    <el-dialog title="新增修复记录" :visible.sync="dialogVisible" @close="cancel" width="450px">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" :rules="rules">
        <el-form-item prop="title">
          <el-input v-model="addForm.title" placeholder="标题"></el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="form.status" placeholder="请选择类型">
            <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="fileId">
          <el-upload v-model="addForm.fileId" :limit="1" action="/singleMuseum/attach/upload" accept=".doc, .docx, .pdf, .xls, .xlsx" :data="configData" :on-preview="handlePreview" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <span style="color: #0590ff;">
              <svg-icon icon-class="upload" class="g-icon-upload mr-5" />
              添加修复方案
            </span>
          </el-upload>
        </el-form-item>

      </el-form>

      <div slot="footer" class="footer mt-30">
        <el-button @click="cancel">取消</el-button>
        <el-button @click="onSubmit" type="primary" :loading="loadingSave">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {

  data() {
    const validateFile = (rule, value, callback) => {
      if (!this.addForm.fileId) {
        callback(new Error('附件不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        name: ''
      },
      loadingSave: false,
      dialogVisible: false,
      addForm: {},
      statusList:[{dictCode:'1', dictName: '待发布'}, {dictCode: '2', dictName: '已发布'}],
      rules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
        ],
        fileId: [{ required: true, validator: validateFile, trigger: 'change' }],
        status: [
          { required: true, message: '状态为空', trigger: 'blur' },
        ],
      },

      configData: { tableName: 'collect' },
      repairId: '',
      tableData: [],
      listLoading: true,
      total: 0,
      listQuery: {
        currentPage: 1,
        size: 10
      }
    }
  },

  mounted() {
    let repairId = this.$route.query.repairId
    this.repairId = repairId

    this.queryFixList()
  },

  methods: {
    queryFixList() {
      this.listLoading = true
      this.tableData = []
      this.$http
        .get('/repair/bsRepairSpecification/pageList', {
          ...this.listQuery,
          id: this.repairId,
        }).then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result.records
            this.total = res.result.total
          } else {
            this.$message.error(res.result.message)
          }
        })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.queryFixList()
    },

    handleAdd() {
      this.dialogVisible = true
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.queryFixList()
    },

    preview(id, edit) {
      window.open('/singleMuseum/repair/bsRepairSpecification/editOnline?id=' + id + '&edit=' + edit + '&userId=admin&userName=admin', '_blank')
    },

    download(item) {
      location.href =
        '/singleMuseum/repair/bsRepairSpecification/download?id=' + item.fileId
    },

    beforeAvatarUpload(file) { },

    handlePreview(file) {
      if (file.url) {
        let fileId = file.url.split('=')[1]
        location.href = '/singleMuseum/attach/downloadFile?attachmentId=' + fileId
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.addForm.fileId = res.result.attId
        if (this.addForm.fileId) {
          this.$refs['addForm'].clearValidate(['fileId'])
        }
      } else {
        this.$message.error(res.message)
      }
    },

    cancel() {
      this.$refs['addForm'].resetFields()
      this.$refs['addForm'].clearValidate()
      this.fileList = []
      this.loadingSave = false
      this.dialogVisible = false
    },

    // 提交
    onSubmit() {
      const self = this
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          this.$http.post('/repair/bsRepairSpecification/add', {
            ...this.addForm,
            managementId: this.repairId,
          }).then(res => {
            this.loadingSave = false
            if (res.success) {
              this.$message.success({
                message: '新增成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.fileList = []
                  self.queryFixList()
                }
              })
            } else {
              this.loadingSave = false
              this.$message.error(res.message)
            }
          })
        } else {
          return false;
        }
      });
    },


    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
  }
}
</script>

<style>
</style>